import { BuiltinType } from './types';
export class BuiltinInterface {
    constructor() {
        this.types = new Set([BuiltinType.Interface]);
        this.canImplement = false;
    }
}

//# sourceMappingURL=BuiltinInterface.js.map
